export function asLimitOffset(q) {
    if (!q)
        return q;
    const next = { ...q };
    if ("pageSize" in next && !("limit" in next)) {
        next.limit = next.pageSize;
        delete next.pageSize;
    }
    if ("page" in next && !("offset" in next)) {
        const page = Number(next.page);
        const limit = Number(next.limit ?? 50);
        if (Number.isFinite(page) && page > 1)
            next.offset = (page - 1) * limit;
        delete next.page;
    }
    return next;
}
export function asBranchQuery(q) {
    const next = asLimitOffset(q);
    if (!next)
        return next;
    if ("branch" in next && !("branch_code" in next)) {
        next.branch_code = next.branch;
        delete next.branch;
    }
    return next;
}
export function withItems(res) {
    const data = res.data;
    if (Array.isArray(data))
        return res;
    const items = Array.isArray(data?.items) ? data.items : [];
    return {
        ...res,
        data: items,
        meta: {
            ...res.meta,
            total: typeof data?.total === "number" ? data.total : res.meta?.total,
            pageSize: typeof data?.limit === "number" ? data.limit : res.meta?.pageSize,
        },
    };
}
export function enc(value) {
    return encodeURIComponent(String(value));
}
//# sourceMappingURL=business.js.map